import { render, staticRenderFns } from "./SSHFormGlobal.vue?vue&type=template&id=6d21f884&"
import script from "./SSHFormGlobal.vue?vue&type=script&lang=js&"
export * from "./SSHFormGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/deploymentVOP/build/VOPWebApp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d21f884')) {
      api.createRecord('6d21f884', component.options)
    } else {
      api.reload('6d21f884', component.options)
    }
    module.hot.accept("./SSHFormGlobal.vue?vue&type=template&id=6d21f884&", function () {
      api.rerender('6d21f884', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/security/SSHFormGlobal.vue"
export default component.exports